import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline'

interface LoadErrorProps {
  /** What we were trying to load, e.g. "shipments". Used in the message. */
  subject: string
  onRetry: () => void
}

/**
 * Shown when a fetch fails.
 *
 * The list pages used to swallow errors and fall through to their empty state,
 * so a permissions error or dropped connection rendered as "No shipments — get
 * started by creating one". That reads as data loss. This makes failure look
 * like failure, and offers a way out.
 */
export default function LoadError({ subject, onRetry }: LoadErrorProps) {
  return (
    <div className="rounded-lg border border-red-200 bg-red-50 py-12 text-center">
      <ExclamationTriangleIcon className="mx-auto h-12 w-12 text-red-400" />
      <h3 className="mt-3 text-base font-medium text-red-900">
        Couldn&apos;t load {subject}
      </h3>
      <p className="mx-auto mt-1 max-w-md text-sm text-red-700">
        This is a connection or permissions problem — your {subject} are still there. Try again in
        a moment.
      </p>
      <button
        onClick={onRetry}
        className="mt-5 inline-flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-700"
      >
        <ArrowPathIcon className="h-4 w-4" />
        Try again
      </button>
    </div>
  )
}
